export enum ActiveClientVerificationOption {
  MasterPassword = "masterPassword",
  Pin = "pin",
  Biometrics = "biometrics",
  None = "none",
}
